import { render } from "./deleteAccount.vue?vue&type=template&id=4f0a06ef&scoped=true"
import script from "./deleteAccount.vue?vue&type=script&lang=js"
export * from "./deleteAccount.vue?vue&type=script&lang=js"

import "./deleteAccount.vue?vue&type=style&index=0&id=4f0a06ef&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0a06ef"]])

export default __exports__